/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookmarkIcon20Regular = forwardRef('BookmarkIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v11.584c0 1.37-1.504 2.21-2.67 1.49l-3.567-2.205a.5.5 0 0 0-.526 0L5.67 18.073c-1.166.72-2.67-.118-2.67-1.489V5Zm3-1.5A1.5 1.5 0 0 0 4.5 5v11.584a.25.25 0 0 0 .381.213l3.568-2.204a2 2 0 0 1 2.102 0l3.568 2.204a.25.25 0 0 0 .381-.213V5A1.5 1.5 0 0 0 13 3.5H6Z" })));
});
